export class Arteh {
    public arteh: string;
}



// WEBPACK FOOTER //
// ./src/providers/rest-server/data/Arteh.ts